/**
 * Parse the `textAlign` attribute from the DOM element
 */
export function parseTextAlignAttr(element) {
    var _a;
    const alignments = ["left", "center", "right"];
    return ((_a = alignments.find((align) => element.classList.contains(`align-${align}`))) !== null && _a !== void 0 ? _a : "left");
}
/**
 * Parse the `size` attribute from the DOM element
 */
export function parseParagraphSize(element) {
    var _a;
    const sizes = ["small", "medium", "large", "extra-large"];
    return ((_a = sizes.find((align) => element.classList.contains(`align-${align}`))) !== null && _a !== void 0 ? _a : "medium");
}
